import { useContext, useEffect, useState } from "react";
import {
  getProtocols,
  createProtocols,
  updateProtocols,
  deleteProtocols,
  reactiveProtocols,
} from "../services/console/rolecatalog/protocols";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
type ActionType = "CREATE" | "UPDATE" | "DELETE" | "REACTIVE";

const handleProtocolsFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createProtocols,
        fnMsg: t("Catalogue.protocolsApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateProtocols,
        fnMsg: t("Catalogue.protocolsApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteProtocols,
        fnMsg: t("Catalogue.protocolsApiDeleteLabel"),
      };
    case "REACTIVE":
        return {
          actionFn: reactiveProtocols,
          fnMsg: t("Catalogue.protocolsApiReactiveLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useProtocols = (type: UseType, protocolId?: number) => {
  const { t, toast, setAppState } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const protocolsAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleProtocolsFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', data?.name)}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getProtocols())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type, protocolId]);

  return {
    data,
    protocolsAction,
    reloadFn,
  };
};
